<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 650 : 'auto'"
    style="z-index: 1200 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('console.connectedTenantsHelp.dialogTitle') }}</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text scrollable class="scrollable mt-4">
        <i18n-t
          keypath="console.connectedTenantsHelp.awayListDialog.p1"
          tag="p"
        >
          <template #nameColumn>
            <span class="font-weight-bold">
              {{ $t('console.name') }}
            </span>
          </template>
          <template #usersColumn>
            <span class="font-weight-bold">
              {{ $t('console.users') }}
            </span>
          </template>
          <template #foldersColumn>
            <span class="font-weight-bold">
              {{ $t('console.folders') }}
            </span>
          </template>
          <template #threeDotsIcon>
            <v-icon icon="mdi-dots-vertical" />
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.awayListDialog.p2"
          tag="p"
        >
          <template #connectTenant>
            <span class="font-weight-bold">
              {{ $t('console.connectTenant') }}
            </span>
          </template>
          <template #acceptRequest>
            <span class="font-weight-bold">
              {{ $t('console.acceptRequest') }}
            </span>
          </template>
        </i18n-t>
        <h3>
          {{ $t('console.connectedTenantsHelp.awayListDialog.connectionActions.manageGroups.subtitle') }}
        </h3>
        <i18n-t
          keypath="console.connectedTenantsHelp.awayListDialog.connectionActions.manageGroups.p1"
          tag="p"
        >
          <template #defaultGroupName>
            <span class="font-weight-bold">
              Default
            </span>
          </template>
          <template #cannot>
            <span class="font-weight-bold font-upper-case">
              {{ $t('common.cannot') }}
            </span>
          </template>
          <template #isNot>
            <span class="font-weight-bold font-upper-case">
              {{ $t('common.isNot') }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          keypath="console.connectedTenantsHelp.awayListDialog.connectionActions.manageGroups.p2"
          tag="p"
        >
          <template #addGroup>
            <span class="font-weight-bold">
              {{ $t('console.addGroup') }}
            </span>
          </template>
          <template #trashIcon>
            <v-icon icon="mdi-delete-sweep-outline" />
          </template>
          <template #save>
            <span class="font-weight-bold">
              {{ $t('common.save') }}
            </span>
          </template>
        </i18n-t>
        <h3>
          {{ $t('console.connectedTenantsHelp.awayListDialog.connectionActions.disconnect.subtitle') }}
        </h3>
        <i18n-t
          keypath="console.connectedTenantsHelp.awayListDialog.connectionActions.disconnect.text"
          tag="p"
        >
          <template #removeConnection>
            <span class="font-weight-bold">
              {{ $t('console.removeConnection') }}
            </span>
          </template>
        </i18n-t>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  name: 'AwayTenantListHelpDialog',
  mixins: [ DialogActionKeys, DialogModel ],
};
</script>

<style lang="scss" scoped>
.font-upper-case {
  text-transform: uppercase;
}

p {
  margin-bottom: 0.75rem;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
}

h3 {
  margin-top: 0.75rem;
}
</style>
